import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'file-upload',
    templateUrl: 'file-upload.component.html',
    styleUrls: ['file-upload.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FileUploadComponent implements OnInit {
    @Output() fileChange: EventEmitter<File> = new EventEmitter<File>();

    @ViewChild('fileInput') fileInput: ElementRef;
    file: File;

    @Input() parentFormGroup: FormGroup;


    ngOnInit(): void {
        this.parentFormGroup.addControl('fileInput', new FormControl(''));
        this.parentFormGroup.addControl('fileName', new FormControl(''));
        this.parentFormGroup.addControl('file', new FormControl(''));
    }

    openInput(event: Event) {
        event.preventDefault();
        this.fileInput.nativeElement.click();
    }

    onFileChange(files: FileList | null) {
        if (files?.length) {
            this.file = files[0];
            this.parentFormGroup.controls['fileName'].setValue(this.file.name);
            this.parentFormGroup.controls['file'].setValue(this.file);
            this.fileChange.emit(this.file);
        }
    }
}
